<template>
  <div class="c-user__body">
    <Viewport v-model="tableHeight">
      <el-table
        :data="tableData"
        :height="tableHeight"
        :summary-method="summaries"
        show-summary
        @sort-change="sortTable"
        v-loading="asyning"
        class="common-el-table-styles summary-el-table-styles"
        ref="rechargeDataTable"
      >
        <el-table-column v-if="tableCol.length" type="index" width="40" label="序号"></el-table-column>
        <el-table-column
          v-for="(col, id) in tableCol"
          :key="id"
          :prop="col.key"
          :label="col.title"
          :fixed="col.fixed"
          :show-overflow-tooltip="col.overflow"
          :min-width="col.width"
          :align="col.align"
          :sortable="col.sortable"
          :sort-orders="['descending', 'ascending', null]"
        >
          <template slot-scope="scope">
            <span v-if="col.key === 'status'">{{ scope.row[col.key] | reStatus }}</span>
            <span v-else-if="['postTime', 'roleTime', 'firstRoleTime'].includes(col.key)">{{ scope.row[col.key] | datetimeToSec }}</span>
            <span v-else>{{ scope.row[col.key] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <Page
        show-total
        show-sizer
        show-elevator
        class="c-table-page pager"
        :total="total"
        :current.sync="pageIndex"
        :page-size="pageSize"
        :page-size-opts="[10, 20, 30, 40, 100]"
        @on-change="changePageIndex"
        @on-page-size-change="changePageSize"
      />
    </Viewport>

    <!-- 自定义列 -->
    <custom-column v-model="modalColumn" :data="tableColumns" :subTitle="['基础数据']" @on-select="selectCustomColumn" />
  </div>
</template>
<script>
import { HOST_API } from '@/api/config'
import { isArray, trim, throttle } from '@/common/js/utils'
import { toThousands } from '@/common/js/filters'
import tableColumns from '../../../data/user_recharge_columns'
import mixinTable from '../../mixin_table'

import CustomColumn from '@/components/converter/custom-column.vue'

import { getUserRoleRechargePage } from '@/api/ptom.data.model'
export default {
  name: 'UserRole',
  mixins: [mixinTable],
  components: { CustomColumn },
  props: {
    asyning: {
      type: Boolean
    },
    detailTime: {
      type: Array,
      required: true
    },
    datePick: {
      type: Array,
      required: true
    },
    platform: {
      type: Number
    },
    productId: {
      type: Number
    },
    chlUserId: {
      type: Number
    },
    sourceId: {
      type: Number
    },
    keyword: {
      type: String
    }
  },
  computed: {
    tableCol() {
      return this.tableColumns.filter((ret) => !ret.show)
    }
  },
  data() {
    return {
      modalColumn: null,
      tableData: [],
      tableColumns: [],
      sumdata: null,
      tableHeight: 300
    }
  },
  methods: {
    getData() {
      const [begin, end] = this.detailTime || []
      const [start, over] = this.datePick

      this.$emit('on-change', true)
      getUserRoleRechargePage({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        keyword: trim(this.keyword),
        platform: this.platform,
        gameId: this.productId,
        chlId: this.chlUserId,
        sourceId: this.sourceId,
        postTimeSearchBegin: begin,
        postTimeSearchEnd: end,
        roleTimeSearchBegin: start,
        roleTimeSearchEnd: over,
        sort: this.sort,
        order: this.order
      })
        .then((data) => {
          if (typeof data !== 'symbol') {
            this.$emit('on-change', false)
            if (!data) return
            const { list, page_info, sum_data } = data
            if (isArray(list) && page_info && sum_data) {
              const { total_number } = page_info
              this.sumdata = sum_data
              this.initTableColumns()
              this.tableData = list
              this.total = total_number || 0
            } else {
              this.tableColumns = []
              this.tableData = []
              this.total = 0
            }
            this.$nextTick(() => {
              this.$refs.rechargeDataTable && this.$refs.rechargeDataTable.doLayout()
            })
          }
        })
        .catch(() => {
          this.$emit('on-change', false)
          this.tableData = []
          this.tableColumns = []
          this.total = 0
        })
    },
    initTableColumns() {
      const shows = this.getCustomStorage('UserRechargeDataCustomColumn') // 同步本地存储自定义列
      if (shows.length) {
        const local_shows = shows
          .filter((ret) => ret)
          .map((ret) => {
            const item = tableColumns.filter((met) => met.key === ret).pop() || {}
            item.show = false
            return item
          })
        const extend_shows = tableColumns
          .filter((ret) => !shows.includes(ret.key))
          .map((ret) => {
            ret.show = true
            return ret
          })
        this.tableColumns = [...local_shows, ...extend_shows]
      } else this.tableColumns = [...tableColumns]
    },
    downData() {
      const [begin, end] = this.detailTime || []
      const [start, over] = this.datePick
      let url = `${HOST_API}/api/ptom/planDataDetail/exportRechargeData`
      url += `?sessionid=${this.$store.state.token}`
      url += `&platform=${this.platform}`
      url += `&gameId=${this.productId}`
      url += `&chlId=${this.chlUserId}`
      url += `&sourceId=${this.sourceId}`
      url += `&postTimeSearchBegin=${begin}`
      url += `&postTimeSearchEnd=${end}`
      url += `&roleTimeSearchBegin=${start}`
      url += `&roleTimeSearchEnd=${over}`
      this.keyword && (url += `&keyword=${trim(this.keyword)}`)
      this.order && (url += `&order=${this.order}`)
      this.sort && (url += `&sort=${this.sort}`)
      window.open(url)
    },
    summaries(param) {
      const { columns } = param
      const data = JSON.parse(JSON.stringify(this.sumdata))
      const sums = []
      columns.forEach((column, index) => {
        const prop = column.property
        const val = prop && parseFloat(data[prop])
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const twoDecimal = ['roleName', 'userId', 'serverName']
        if (twoDecimal.includes(prop)) sums[index] = val
        else if (prop === 'orderMoney') sums[index] = toThousands(val)
        else sums[index] = ''
      })
      return sums
    },
    selectCustomColumn(params) {
      const tableColumns = params.sort((a, b) => (a._time || 0) - (b._time || 0))
      this.$set(this, 'tableColumns', tableColumns)
      this.modalColumn = false
    }
  },
  watch: {
    detailTime() {
      throttle(() => {
        this.pageIndex = 1
        this.getData()
      }, 300)()
    },
    tableColumns: {
      handler(nVal) {
        const show = nVal.filter((ret) => !ret.show).map((met) => met.key)
        this.setCustomStorage('UserRechargeDataCustomColumn', show)
        this.$nextTick(() => {
          this.$refs.rechargeDataTable && this.$refs.rechargeDataTable.doLayout()
        })
      },
      deep: true
    }
  },
  created() {
    this.getData()
  },
  filters: {
    reStatus(cell) {
      if (cell === '3') return '充值成功'
      else return ''
    }
  },
  beforeDestroy() {
    this.tableData = []
    this.tableColumns = []
    this.total = 0
  }
}
</script>
<style lang="scss" scoped>
.c-user__body {
  height: 100%;

  .c-table-page {
    font-size: 12px;
    padding: 0 8px;
    margin-top: 7px;
    text-align: right;
  }
}
</style>
